import { render, staticRenderFns } from "./TicketCategories.vue?vue&type=template&id=f1a51950&scoped=true&"
import script from "./TicketCategories.vue?vue&type=script&lang=js&"
export * from "./TicketCategories.vue?vue&type=script&lang=js&"
import style0 from "./TicketCategories.vue?vue&type=style&index=0&id=f1a51950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a51950",
  null
  
)

export default component.exports